import ApiConfig from "../config/ApiConfig";

const getCounty = async (addressComponents, lat, lng) => {
  let county = null;
  let countyFips = null;
  let stateFips = null;

  // Try to get the county from the backend
  if (lat != null && lng != null) {
    try {
      const countyUrl = new URL(
        ApiConfig.protocol +
          ApiConfig.apiUri +
          ApiConfig.irqInfoEndpoint +
          `/county?lat=${lat}&lng=${lng}`
      );
      const response = await fetch(countyUrl);
      const data = await response.json();

      // Extract county and FIPS codes from backend response
      if (data?.county) {
        county = data.county;
      }
      if (data?.countyFips) {
        countyFips = data.countyFips;
      }
      if (data?.stateFips) {
        stateFips = data.stateFips;
      }
    } catch (error) {
      console.error("Error fetching county from backend:", error);
      // Fall through to Google API fallback
    }
  }

  // Fallback to Google API county
  if (!county) {
    const countyObj = addressComponents.find((item) =>
      item.types.includes("administrative_area_level_2")
    );
    county = countyObj?.long_name;
  }
  // Fallback to Google API city
  const cityObj = addressComponents.find((item) =>
    item.types.includes("locality")
  );
  const city = cityObj.long_name;
  if (!county) {
    county = `${city} City`;
  }
  //remove " County"
  if (county && county.slice(-7) === " County") {
    county = county.slice(0, -7);
  }

  return { county, countyFips, stateFips };
};

export default getCounty;
